<template>
  <main v-if="currentStatus==1">
    
    <div id="stream" class="rounded bg-enabled zoom-animate " :class="!showLiveStream ? 'd-block' : 'd-none'"
          @click="showLiveStream = true" >
      Tranmisión en Vivo  <i class="fa fa-rss ml-2 shadow" style="color:#f00"/>      
    </div>

    <div id="stream_player" :class="showLiveStream? 'd-block' : 'd-none'">
      <button @click="showLiveStream=false">-</button>
      <iframe :src="streamUrl" allowfullscreen class="w-100" style="height:100%" frameborder="0"></iframe>
    </div>

  </main>
</template>

<script>
export default {
  sockets: {
    stream_client_change: function (data) {
      this.currentStatus = data.status;
      this.streamUrl = data.url;
    },
    stream_client_change_test: function (data) {
      console.log("stream change... ", data)
      this.currentStatus = data.status;
      this.streamUrl = data.url;
    },
  },
  data() {
    return {
      currentStatus: 0,
      streamUrl: "",
      showLiveStream: false,
    };
  },

  watch: {
    currentStatus: function (val) {
      // if (val == 1) this.showLiveStream =true            
      this.showLiveStream = val == 1
    },
  },

  async mounted() {

    const req = await fetch(this.$store.state.url + "api/stream");
    const res = await req.json();

    this.currentStatus = res.status;
    this.streamUrl = res.url;
  },
  methods: {},
};
</script>

<style>
#stream {
  z-index: 2147483647;
  position: fixed;
  bottom: 0;

  padding: 1.5rem;
  color: #fff;
  text-align: center;

  box-shadow: 0px 0px 2rem rgba(250, 250, 250, 0.3);
}
.bg-enabled {
  background: #111;
  cursor: pointer;
}
.bg-disabled {
  background: #333;
}

.zoom-animate {
  animation-name: zoom;
  animation-duration: 3s;
  animation-iteration-count: infinite;
}

@keyframes zoom {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

#stream_player {
  position: fixed;
  bottom: 0;
  width: 35rem;
  max-width: 95vw;
  height: 20rem;
  background: #fff;
  z-index: 999;
  border: none;  
}

#stream_player button {
  position: absolute;
  right: -10px;
  top: -4px;
  border: none;
  background: #222;
  color: #fff;
  height: 2.5rem;
  width: 3rem;
  cursor: pointer;
  font-size: 2rem;
  
}
</style>